<template>
  <!-- Total: 5+5+5+9+5+6+1 = 36 spans -->
  <div>
    <div class="cardLayoutWrapper">
      <BasicCell
        :span="5"
        extra-class="elem--clickable"
      >
        <span @click="displayVirement(item.code)">{{ item?.reference }}</span>
      </BasicCell>
      <BasicCell :span="5">{{ dateTimeToReadableDate(item?.dateEmission) }}</BasicCell>
      <BasicCell
        :span="5"
        extra-class="elem--nowrap"
      >
        {{ `${formatNumber(item?.montantTTC, { decimal: 2, separateur: true })} €` }}
      </BasicCell>
      <BasicCell
        :span="9"
        extra-class="elem--nowrap"
      >
        {{ item?.denominationBeneficiaire }}
      </BasicCell>
      <BasicCell
        :span="5"
        extra-class="elem--nowrap"
      >
        {{ item?.codeFacture === 'Multi' ? 'Multi' : item?.factures?.[0]?.reference }}
      </BasicCell>
      <BasicCell
        :span="6"
        extra-class="elem--nowrap"
      >
        {{ item?.codeDossier }}
      </BasicCell>
      <BasicCellActionIcon
        :span="1"
        icon-name="eye"
        :hover-messages="{ actif: 'Consulter le virement' }"
        @click="() => displayVirement(item.code)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { VirementDTO } from '@/features/api/extranet/dto/Virement'
  import { dateTimeToReadableDate } from '@/features/shared/tools/date'
  import { formatNumber } from '@/features/shared/tools'
  import { useRechercheVirementActions } from '../useRechercheVirementActions'
  import BasicCell from '@designSystem/components/basic/cell/BasicCell.vue'
  import BasicCellActionIcon from '@designSystem/components/basic/cell/BasicCellActionIcon.vue'

  defineProps<{ item: VirementDTO }>()

  const { displayVirement } = useRechercheVirementActions()
</script>

<style scoped>
  @import '../../index.less';
</style>
